export const DeleteUserGroupFlags = {
  SELF_ONLY: 'self_only',
  SELF_WITH_CHILDREN: 'with_children',
};
